export default __webpack_public_path__ + "cf964fbaf1bd1ac2f52fae6405ba2129.jpg";